import { ActivityReport } from '../../../shared/activity-report/activity-report';
import { dataMember, required } from 'santee-dcts';
import { deserializers } from '../../../core';
import { Moment } from 'moment';
import { siteDisplayNameRenderer } from '../../../renderer/site-display-name-renderer';

export class AdminLabReportActivityReport extends ActivityReport {
    @dataMember()
    @required()
    public reportId: string;

    @dataMember()
    @required()
    public sponsorName: string;

    @dataMember()
    @required({ nullable: true})
    public protocolName: string;

    @dataMember()
    @required({ nullable: true })
    public zcProjectNumber: string;

    @dataMember()
    @required()
    public siteName: string;

    @dataMember()
    @required({ nullable: true })
    public siteNum: string;

    @dataMember()
    @required({ nullable: true })
    public country: string;

    @dataMember()
    @required({ nullable: true })
    public visit: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public visitCollectionDate: Moment;

    @dataMember()
    @required({ nullable: true })
    public accessionNumber: string;

    @dataMember()
    @required({ nullable: true })
    public subjectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public subjectInitials: string;

    @dataMember()
    @required({ nullable: true })
    public screeningNumber: string;

    @dataMember()
    @required({ nullable: true })
    public zcSubjectId: string;

    @dataMember()
    @required({ nullable: true })
    public type: string;

    @dataMember()
    @required({ nullable: true })
    public userName: string;

    @dataMember()
    @required({ nullable: true })
    public email: string;

    @dataMember()
    @required({ nullable: true })
    public blindingRole: string;

    @dataMember()
    @required({ nullable: true })
    public studyRole: string;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({siteNumber: this.siteNum, investigatorFullName: this.siteName});
    }
}
